import { intervalToDuration, formatDuration } from 'date-fns';
import NamedDto from 'modules/base/dto/NamedDto';
import SchedulingEditDto from './SchedulingEditDto';
import SensorConfigDto from './SensorConfigDto';

export default class DeviceEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.deviceType = null;
		/** @type {string} */
		this.externalName = null;
		/** @type {number} */
		this.externalId = null;
		/** @type {string} */
		this.model = null;
		/** @type {string} */
		this.version = null;
		/** @type {string} */
		this.MAC = null;
		/** @type {string} */
		this.IP = null;
		/** @type {number} */
		this.batteryLevel = null;
		/** @type {number} */
		this.boardTemperature = null;
		/** @type {number} */
		this.uptime = null;
		// /** @type {number} */
		// this.infrastructureElement = null;
		// /** @type {number} */
		// this.location = null;
		/** @type {string} */
		this.classificationAlgorithmStatus = null;
		/** @type {number[]} */
		this.activeSensorList = null;
		/** @type {number} */
		this.schedStartTime = null;
		/** @type {number} */
		this.schedMonitorTimeInSec = null;
		/** @type {number} */
		this.schedSleepTimeInSec = null;
		/** @type {number} */
		this.schedStopTime = null;
		/** @type {number} */
		this.project = null;
		/** @type {SchedulingEditDto[]} */
		this.schedulingList = null;
		/** @type {string} */
		this.status = null;
		/** @type {SensorConfigDto[]} **/
		this.sensorConfigs = null;
	}

	/**
	 * @typedef {Object} _DeviceEditDtoProps
	 * @property {number} deviceType
	 * @property {string} externalName
	 * @property {number} externalId
	 * @property {string} model
	 * @property {string} version
	 * @property {string} MAC
	 * @property {string} IP
	 * @property {number} batteryLevel
	 * @property {number} boardTemperature
	 * @property {number} uptime
	 * @property {number} infrastructureElement
	 * @property {number} location
	 * @property {string} classificationAlgorithmStatus
	 * @property {number[]} activeSensorList
	 * @property {number} schedStartTime
	 * @property {number} schedMonitorTimeInSec
	 * @property {number} schedSleepTimeInSec
	 * @property {number} schedStopTime
	 * @property {number} project
	 * @property {SchedulingEditDto[]} schedulingList
	 * @property {string} status
	 * @property {SensorConfigDto[]} sensorConfigs
	 * @typedef {import("../NamedDto").NamedDtoProps & _DeviceEditDtoProps} DeviceEditDtoProps
	 */
	/**
	 *
	 * @param {DeviceEditDtoProps} props
	 * @returns {DeviceEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.deviceType = props.deviceType;
		this.externalName = props.externalName;
		this.externalId = props.externalId;
		this.model = props.model;
		this.version = props.version;
		this.MAC = props.MAC;
		this.IP = props.IP;
		this.batteryLevel = props.batteryLevel !== null ? Math.ceil(props.batteryLevel * 100) / 100 : null;
		this.boardTemperature = props.boardTemperature !== null ? Math.ceil(props.boardTemperature * 100) / 100 : null;
		this.uptime = props.uptime;
		// this.infrastructureElement = props.infrastructureElement;
		// this.location = props.location;
		this.classificationAlgorithmStatus = props.classificationAlgorithmStatus;
		this.activeSensorList = props.activeSensorList !== null ? props.activeSensorList : [];
		this.schedStartTime = props.schedStartTime;
		this.schedMonitorTimeInSec = props.schedMonitorTimeInSec;
		this.schedSleepTimeInSec = props.schedSleepTimeInSec;
		this.schedStopTime = props.schedStopTime;
		this.project = props.project;
		this.schedulingList = Array.isArray(props.schedulingList) ? props.schedulingList.map(d => new SchedulingEditDto().setup(d)) : [];
		this.status = props.status;
		this.sensorConfigs = props.sensorConfigs;
		return this;
	}
}
